import axios from 'axios';

import {
  AbsenceFormation,
  AdditionalFormation,
  Formation,
  FunctionCapacityBalance,
  PeriodHour
} from 'components/types';

import { CAPACITY, CAPACITY_BALANCE } from 'RestAPIs/endpoints';

import { VIEW } from 'components/roster-portal/capacity/Formation/const';

type GetCapacityOptions = {
  aggregateOn: typeof VIEW.MONTH | typeof VIEW.WEEK;
  scenarioId: number;
  year: number;
  functionId: number | null;
  costCenterId: number | null;
  quarter: number | null;
};

export type CapacityResponse = {
  grossFormation: Formation;
  absenceFormation: AbsenceFormation;
  loanFormation: AdditionalFormation;
  additionalFormation: AdditionalFormation;
  netTeamFormation: Formation;
  netFormation: Formation;
};

type GetCapacityBalanceOptions = {
  aggregateOn: typeof VIEW.MONTH | typeof VIEW.WEEK;
  scenarioId: number;
  year: number;
  quarter: number | null;
};

export type CapacityBalanceResponse = {
  periodHourBalances: PeriodHour[];
  totalYearHoursBalance: number;
  functionCapacityBalances?: FunctionCapacityBalance[];
};

export const getCapacity = (options: GetCapacityOptions) => {
  const { scenarioId, aggregateOn, functionId, costCenterId, year, quarter } =
    options;
  const params = {
    aggregateOn,
    functionId,
    costCenterId,
    year,
    quarter
  };

  return axios.get<CapacityResponse>(CAPACITY, {
    params,
    pathParams: { scenarioId }
  });
};

export const getCapacityBalance = (options: GetCapacityBalanceOptions) => {
  const { scenarioId, year, aggregateOn, quarter } = options;
  const params = {
    year,
    aggregateOn,
    quarter
  };

  return axios.get<CapacityBalanceResponse>(CAPACITY_BALANCE, {
    params,
    pathParams: { scenarioId }
  });
};
